module.exports = __webpack_public_path__ + "img/about-icons-story-web.6756b0e7.svg";